import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';

@Component({
  selector: 'app-mini-pricer-dlg',
  templateUrl: './mini-pricer-dlg.component.html',
  styleUrls: ['./mini-pricer-dlg.component.scss']
})
export class MiniPricerDlgComponent implements OnInit {

  @Output() closeDialog: EventEmitter<any> = new EventEmitter();

  title = 'mini-pricer';
  mode = 'SEARCH';

  constructor(public bsModalRef: BsModalRef) {

  }

  ngOnInit(): void {
  }


  modeOut($event: any) {
    this.mode = $event;
  }

  close() {
    this.bsModalRef.hide();
    this.closeDialog.emit();
  }
}
